import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

/**
 * Kort avmeldingslenke fra SMS: <domene>/a/<kode> (5.10.2026).
 *
 * Den lange lenken med nummer og signatur ble for mye tekst i en SMS. Her
 * slaas koden opp i Ascendly, og kunden sendes videre til /avmeld med den
 * vanlige signerte lenken, som gjoer selve avmeldingen.
 */
const CONVEX = "https://bold-pony-700.eu-west-1.convex.cloud";
const NAVN = "Drammen Car Wash";

export const Route = createFileRoute("/a/$kode")({
  head: () => ({ meta: [{ title: `Avmelding | ${NAVN}` }, { name: "robots", content: "noindex" }] }),
  component: KortAvmelding,
});

function KortAvmelding() {
  const { kode } = Route.useParams();
  const [feil, setFeil] = useState(false);

  useEffect(() => {
    let aktiv = true;
    fetch(`${CONVEX}/api/query`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: "avmelding:fraKortkode", args: { kode }, format: "json" }),
    })
      .then((r) => r.json())
      .then((svar: { status?: string; value?: { k: string; s: string } | null }) => {
        if (!aktiv) return;
        const v = svar.status === "success" ? svar.value : null;
        if (!v) {
          setFeil(true);
          return;
        }
        window.location.replace(`/avmeld?k=${encodeURIComponent(v.k)}&s=${encodeURIComponent(v.s)}`);
      })
      .catch(() => aktiv && setFeil(true));
    return () => {
      aktiv = false;
    };
  }, [kode]);

  return (
    <main className="flex min-h-[70vh] flex-col items-center justify-center px-4 py-16">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-sm">
        {feil ? (
          <>
            <h1 className="text-2xl font-semibold text-foreground">Ugyldig lenke</h1>
            <p className="mt-3 text-muted-foreground">Åpne hele lenken fra meldingen og prøv igjen.</p>
          </>
        ) : (
          <p className="text-muted-foreground">Melder deg av …</p>
        )}
      </div>
    </main>
  );
}
